import { get, post, del } from "services/api"
import { currentAccountId } from "services/authentication"
import { ApiKey } from "sharedTypes"

const apiKeysBaseURL = (eventId: string) => `${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/events/${eventId}/api_keys`

export const getApiKeys = (eventId: string) => get<{ data: ApiKey[] }>(`${apiKeysBaseURL(eventId)}.json`)

export const postApiKey = (eventId: string, label: string) => post<ApiKey>(`${apiKeysBaseURL(eventId)}.json`, { label })

export const deleteApiKey = (eventId: string, apiKeyId: string) => del<void>(`${apiKeysBaseURL(eventId)}/${apiKeyId}.json`)
